import {
  Box,
  Typography,
  Container,
  Paper,
  List,
  ListItem,
  Button,
  Dialog,
  IconButton,
} from "@mui/material";
import { motion } from "framer-motion";
import WorkIcon from "@mui/icons-material/Work";
import VerifiedIcon from "@mui/icons-material/Verified";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const experiences = [
  {
    title: "Full Stack Web Development Intern (On-Site, Paid)",
    company: "Appinion BD Limited",
    duration: "Oct 2025 - Feb 2026",
    description: [
      "Developed full-stack web applications using Laravel and MySQL with RESTful APIs.",
      "Designed and optimized database schemas for efficient query performance.",
      "Collaborated with senior developers to implement features and improve application performance.",
      "Hands-on experience in the complete web development lifecycle.",
    ],
    certificate: {
      title: "Full Stack Web Development Internship Certificate",
      issuedDate: "February 2026",
      certificateUrl: "/media/certificates/appinion-internship-certificate.jpg",
    },
  },
];

const Experience = () => {
  const [openCertificate, setOpenCertificate] = useState(null);

  const handleOpenCertificate = (certificateUrl) => {
    setOpenCertificate(certificateUrl);
  };

  const handleCloseCertificate = () => {
    setOpenCertificate(null);
  };
  return (
    <Box id="experience" sx={{ py: 8, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Professional Experience
          </Typography>
          {experiences.map((exp, index) => (
            <Paper key={index} elevation={3} sx={{ p: 4, mb: 4 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <WorkIcon color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h6">{exp.title}</Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {exp.company} • {exp.duration}
                  </Typography>
                </Box>
              </Box>
              <List>
                {exp.description.map((item, i) => (
                  <ListItem
                    key={i}
                    sx={{
                      display: "list-item",
                      listStyleType: "disc",
                      pl: 0,
                      ml: 2,
                    }}
                  >
                    <Typography variant="body1">{item}</Typography>
                  </ListItem>
                ))}
              </List>
              {exp.certificate && (
                <Box
                  sx={{
                    mt: 3,
                    pt: 3,
                    borderTop: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <VerifiedIcon sx={{ color: "success.main" }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Certificate
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {exp.certificate.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mb: 2, display: "block" }}
                  >
                    Issued: {exp.certificate.issuedDate}
                  </Typography>
                  {exp.certificate.certificateUrl && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() =>
                        handleOpenCertificate(exp.certificate.certificateUrl)
                      }
                      startIcon={<DescriptionIcon />}
                      sx={{ mt: 1 }}
                    >
                      View Certificate
                    </Button>
                  )}
                </Box>
              )}
            </Paper>
          ))}
        </motion.div>
      </Container>

      {/* Certificate Modal - Full View No Scroll */}
      <Dialog
        open={!!openCertificate}
        onClose={handleCloseCertificate}
        fullScreen
        PaperProps={{
          sx: {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {/* Close Button */}
          <IconButton
            edge="end"
            onClick={handleCloseCertificate}
            aria-label="close"
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              zIndex: 10,
              backgroundColor: "#fff",
              color: "#000",
              width: 44,
              height: 44,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          >
            <CloseIcon sx={{ fontSize: 24 }} />
          </IconButton>

          {/* Content Container */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto",
            }}
          >
            {openCertificate && openCertificate.endsWith(".pdf") ? (
              <iframe
                src={`${openCertificate}#toolbar=0&navpanes=0`}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                title="Certificate"
              />
            ) : (
              <Box
                component="img"
                src={openCertificate}
                alt="Certificate"
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Experience;
